import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent {
	title = 'axon-self-enrollment-gui';
	onActivate(event) {
		window.scroll(0, 0);
	}

	constructor(private translate: TranslateService) {
		translate.addLangs(['en', 'pt']);
		translate.setDefaultLang('pt');

		const browserLang = translate.getBrowserLang();
		translate.use(browserLang.match(/en|pt/) ? browserLang : 'en');
	}

	changeLanguage(lang: string) {
		this.translate.use(lang);
	}
}
